import React, { Component } from 'react'

// Components
import Select from 'react-select'
import 'react-select/dist/react-select.css'

class MonthDropdown extends Component {
    constructor(props){
        super(props)
        this.state = {
            months: [
                {
                    'value': 1,
                    'label': '01'
                },
                {
                    'value': 2,
                    'label': '02'
                },
                {
                    'value': 3,
                    'label': '03'
                },
                {
                    'value': 4,
                    'label': '04'
                },
                {
                    'value': 5,
                    'label': '05'
                },
                {
                    'value': 6,
                    'label': '06'
                },
                {
                    'value': 7,
                    'label': '07'
                },
                {
                    'value': 8,
                    'label': '08'
                },
                {
                    'value': 9,
                    'label': '09'
                },
                {
                    'value': 10,
                    'label': '10'
                },
                {
                    'value': 11,
                    'label': '11'
                },
                {
                    'value': 12,
                    'label': '12'
                }
            ],
            defaultMonth: new Date().getMonth()
        }

        // If months collection was given
        if(props.months){
            this.state = {
                months: props.months
            }
        }

        // If default month was given
        if(props.defaultMonth){
            this.state = {
                ...this.state,
                defaultYear: props.defaultYear
            }
        }
    }

    updateSelection = (selection) => {
        this.props.handleChange(selection)
    }

    render() {
        let { month = '' } = this.props
        // if(month === '') this.props.handleChange(this.state.defaultMonth)

        return (
            <Select
                name={`month`}
                placeholder='Select Month'
                value={month}
                onChange={(selection) => this.updateSelection(selection.value)}
                clearable={false}
                options={this.state.months}
            />
        )
    }
}

export default MonthDropdown



// WEBPACK FOOTER //
// ./src/components/MonthDropdown.js